<template>
    <div class="flex flex-col gap-2">   

        <div
            class="flex justify-center items-center py-4 space-x-2"
        >
            <button
            class="w-8 h-8 text-xs bg-gray-300 rounded-full"
            v-if="currentBlock !== 0"
            @click="prevBlock"
          >
            &lt;
          </button>
            
            <button
              class="w-8 h-8 text-xs bg-gray-200 rounded-full disabled:opacity-50"
              :disabled="currentPage === 1"
              @click="prevPage"
            >
              &laquo;
            </button>

            <button
              v-for="page in visiblePages"
              :key="page"
              class="w-8 h-8 text-xs rounded-full"
              :class="{
                'bg-blues text-white': currentPage === page,
                'bg-white border border-gray-400 text-gray-800':
                  currentPage !== page,
              }"
              @click="changePage(page)"
            >
              {{ page }}
            </button>

            <button
              class="w-8 h-8 text-xs bg-gray-200 rounded-full disabled:opacity-50"
              :disabled="currentPage >= totalPages"
              @click="nextPage"
            >
              &raquo;
            </button>

            <button
              class="w-8 h-8 text-xs bg-gray-300 rounded-full"
              v-if="((currentBlock + 1) * pageSize) < totalPages"
              @click="nextBlock"
            >
              &gt;
            </button>

          </div>

          <p class="text-xs text-center">{{currentPage}}/{{ totalPages }} Pages</p>

    </div>
</template>


<script> 


export default {
    
    name: "Pagination",

    data(){
        return {
            currentPage: 1,
            pageSize: 5,
            // pageArray: [],
        }
    },

    props: ["totalPages"], 

    computed: {
        pageArray() {
          return Array.from({ length: this.totalPages }, (_, i) => i + 1);
        },
        visiblePages() {
            const start =
                Math.floor((this.currentPage - 1) / this.pageSize) * this.pageSize;
            const end = Math.min(start + this.pageSize, this.totalPages);
            return this.pageArray.slice(start, end);
        },
        currentBlock() {
          return Math.floor((this.currentPage - 1) / this.pageSize);
        },
    },

    methods: {
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                this.$emit('page-changed', this.currentPage);
                
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.$emit('page-changed', this.currentPage);
                
            }
        },

        changePage(page) {
            this.currentPage = page;
            this.$emit('page-changed', this.currentPage);
        },

        nextBlock() {
          const newPage = (this.currentBlock + 1) * this.pageSize + 1;
          if (newPage <= this.totalPages) {
            this.currentPage = newPage;
            this.$emit("page-changed", this.currentPage);
          }
        },
        prevBlock() {
          const newPage = (this.currentBlock - 1) * this.pageSize + 1;
          if (newPage >= 1) {
            this.currentPage = newPage;
            this.$emit("page-changed", this.currentPage);
          }
        },

    },


}

</script>


<style> 

</style>